"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmProfileAsResumeModal = ConfirmProfileAsResumeModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const icons_1 = require("@ant-design/icons");
const account_1 = require("@src/types/account");
function getEmptyFieldText(emptyField) {
    switch (emptyField) {
        case account_1.AccountEmptyFieldsNames.birth_date:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.birth_date" });
        case account_1.AccountEmptyFieldsNames.description:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.description" });
        case account_1.AccountEmptyFieldsNames.profile_picture_url:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.profile_picture" });
        case account_1.AccountEmptyFieldsNames.telephone:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.phone_number" });
        case account_1.AccountEmptyFieldsNames.job:
            return ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.job" }), " *"] }));
        case account_1.AccountEmptyFieldsNames.school:
            return ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.school" }), " *"] }));
        case account_1.AccountEmptyFieldsNames.language:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.language" });
        case account_1.AccountEmptyFieldsNames.certificate:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.certificate" });
        case account_1.AccountEmptyFieldsNames.social_media:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.social_media" });
        case account_1.AccountEmptyFieldsNames.portfolio:
            return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.portfolio" });
        default:
            break;
    }
}
const EmptyFields = ({ profileEmptyFields }) => {
    return ((0, jsx_runtime_1.jsx)("ul", { children: profileEmptyFields.map(emptyField => {
            const emptyFieldName = getEmptyFieldText(emptyField);
            if (!emptyFieldName) {
                return null;
            }
            return (0, jsx_runtime_1.jsx)("li", { children: emptyFieldName }, emptyField);
        }) }));
};
function ConfirmProfileAsResumeModal(props) {
    const intl = (0, react_intl_1.useIntl)();
    const EmptyFieldsText = () => ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.modal.has_empty_fields", values: {
                    breakingLine: (0, jsx_runtime_1.jsx)("br", {}),
                } }), (0, jsx_runtime_1.jsx)(EmptyFields, { profileEmptyFields: props.profileEmptyFields }), props.hasEmptyRequiredFields && ((0, jsx_runtime_1.jsx)(elements_1.Link, { className: "flex-row justify-center m-b-m", to: "/ucet/profil/uprava-profilu", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, { className: "m-r-m" }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.change_profile" }) }) })), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.modal.you_can_fill", values: {
                    link: chunks => (0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/ucet/profil/uprava-profilu", children: chunks }),
                } }), props.hasEmptyRequiredFields && ((0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.modal.has_empty_required_fields" }) }))] }));
    const CompleteFilledFieldsText = () => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.modal.fully_filled_fields", values: {
                link: chunks => (0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/ucet/profil", children: chunks }),
            } }) }));
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { visible: props.visible, destroyOnClose: true, closable: false, okButtonProps: { ...props.okButtonProps, disabled: props.hasEmptyRequiredFields }, onCancel: () => props.setShowConfirmationModal(false), onOk: () => props.setShowConfirmationModal(false), okText: intl.formatMessage({
            id: 'profile.resume.modal.button_accept',
        }), cancelText: intl.formatMessage({
            id: 'profile.resume.modal.button_cancel',
        }), title: intl.formatMessage({
            id: 'profile.resume.modal.title',
        }), children: [props.profileEmptyFields.length > 0 && (0, jsx_runtime_1.jsx)(EmptyFieldsText, {}), props.profileEmptyFields.length === 0 && (0, jsx_runtime_1.jsx)(CompleteFilledFieldsText, {})] }));
}
